import { useState } from "react";

const useForm = (initialState, onSubmit) => {
    const [form, setForm] = useState(initialState);
    const [states, setStates] = useState({ loading: false, success: false, failure: false });

    const handleChange = (event) => {
        const { name, value } = event.target;
        setForm({ ...form, [name]: value });
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        setStates({ loading: true, success: false, failure: false, mismatch: false });

        try {
            const result = await onSubmit(form);
            if (result.mismatch) {
                setStates({ loading: false, success: false, failure: false, mismatch: true });
                return;
            }
            setStates({ loading: false, success: true, failure: false, mismatch: false });
        } catch (error) {

            setStates({ loading: false, success: false, failure: false, mismatch: false });
        }
    }
    
    return { form, handleChange, handleSubmit, states };
}

export default useForm;